// Modül 2 - Havayolları Adaydan Ne Bekler? - Ek İçerikler

const cabinCrewContentsM2Extra = {
  // Ünite 3 - Kişilik Özellikleri
  'CM-M2-U3-L1': {
    title: 'Aranan Kişilik Özellikleri',
    type: 'lesson',
    content: {
      introduction: 'Havayollarının kabin memuru adaylarında aradığı temel kişilik özellikleri.',
      sections: [
        {
          title: 'Empati ve Duygusal Zeka',
          content: 'Yolcuların duygusal durumunu anlama ve uygun şekilde karşılık verme yeteneği. Uçuş korkusu olan, stresli veya üzgün yolculara yaklaşım.'
        },
        {
          title: 'Esneklik ve Adaptasyon',
          content: 'Değişen koşullara hızlı uyum sağlama. Rötar, iptal, zor yolcu gibi beklenmedik durumlarda sakin kalabilme.'
        },
        {
          title: 'Stres Yönetimi',
          content: 'Baskı altında performans gösterebilme. Acil durumlarda panik yapmadan prosedürleri uygulama.'
        },
        {
          title: 'Pozitif Tutum',
          content: 'Güleryüz, enerjik duruş, çözüm odaklı yaklaşım. Olumsuz durumlarda bile profesyonel kalabilme.'
        }
      ],
      tips: ['Bu özellikler geliştirilebilir', 'Kendinizi tanıyın ve eksik alanlarınızda çalışın', 'Mülakatta bu özellikleri gösterin']
    }
  },
  'CM-M2-U3-L2': {
    title: 'Kültürel Farkındalık',
    type: 'lesson',
    content: {
      introduction: 'Uluslararası ortamda çalışmanın gerektirdiği kültürel bilinç ve saygı.',
      sections: [
        {
          title: 'Kültürel Duyarlılık Nedir?',
          content: 'Farklı kültürlerin değerlerine, inançlarına ve davranış kalıplarına saygı gösterme ve anlayışla yaklaşma.'
        },
        {
          title: 'Pratik Örnekler',
          content: 'Yemek tercihleri (helal, koşer, vejetaryen), selamlama şekilleri, göz teması normları, dokunma kuralları.'
        },
        {
          title: 'Dini ve Özel Günler',
          content: 'Ramazan, Noel, Diwali gibi özel dönemlerde yolcu beklentileri ve uygun hizmet sunumu.'
        }
      ],
      tips: ['Önyargısız olun', 'Sormaktan çekinmeyin', 'Hata yaparsanız özür dileyin ve öğrenin']
    }
  },
  'CM-M2-U3-L3': {
    title: 'Senaryo: Kültürel Durum',
    type: 'scenario',
    scenario: {
      title: 'Yemek Servisi Sorunu',
      situation: 'Business class\'ta oturan bir yolcu, sizden özel yemek istemiş ancak sistemde kaydı yok. Yolcu çok kızgın ve sesini yükselterek \'Bunu her uçuşta yaşıyorum, bu kabul edilemez!\' diyor.',
      question: 'Bu durumu nasıl yönetirsiniz?',
      options: [
        { id: 'a', text: 'Yolcuya sakinleşmesini söyler ve kuralları açıklarım', correct: false },
        { id: 'b', text: 'Özür diler, mevcut alternatiflerden uygun olanı sunar ve gelecek için not alırım', correct: true },
        { id: 'c', text: 'Purser\'ı çağırıp sorumluluğu devrederim', correct: false },
        { id: 'd', text: 'Sistemin hatasını söyleyip elimden bir şey gelmediğini belirtirim', correct: false }
      ],
      explanation: 'Önce empati ve özür, sonra çözüm. Suçlama değil, çözüm odaklı yaklaşım profesyonelliktir.'
    }
  },
  'CM-M2-U3-L4': {
    title: '🎮 Kişilik Eşleştirme',
    type: 'matching',
    game: {
      instruction: 'Kişilik özelliğini doğru durumla eşleştirin.',
      pairs: [
        { left: 'Empati', right: 'Uçuş korkusu olan yolcuyu sakinleştirme' },
        { left: 'Esneklik', right: '3 saatlik rötar sonrası programı yeniden düzenleme' },
        { left: 'Stres yönetimi', right: 'Türbülansta yolculara güven verme' },
        { left: 'Pozitif tutum', right: 'Gece uçuşunda güleryüzlü servis' },
        { left: 'Kültürel farkındalık', right: 'Helal yemek talebi için alternatif bulma' }
      ],
      timeLimit: 60
    }
  },

  // Ünite 4 - Dil ve İletişim
  'CM-M2-U4-L1': {
    title: 'İngilizce Gereksinimleri',
    type: 'lesson',
    content: {
      introduction: 'Kabin memurluğu için İngilizce seviyesi beklentileri ve değerlendirme kriterleri.',
      sections: [
        {
          title: 'Minimum Gereksinim',
          content: 'Çoğu uluslararası havayolu minimum B2 seviyesi (CEFR) ister. THY dahil birçok havayolu TOEIC veya IELTS puanı talep eder.'
        },
        {
          title: 'Havacılık İngilizcesi',
          content: 'Genel İngilizcenin ötesinde, havacılık terimleri ve standart anonslarda akıcılık gerekir.'
        },
        {
          title: 'Mülakatta İngilizce',
          content: 'Genellikle İngilizce mülakat bölümü vardır. Spontane konuşma, telaffuz ve anlama becerisi değerlendirilir.'
        }
      ],
      tips: ['Günlük pratik yapın', 'Havacılık İngilizcesi özelinde çalışın', 'Telaffuza önem verin']
    }
  },
  'CM-M2-U4-L2': {
    title: 'İkinci Dil Avantajı',
    type: 'lesson',
    content: {
      introduction: 'Birden fazla dil bilmenin kabin memurluğu kariyerinde sağladığı avantajlar.',
      sections: [
        {
          title: 'Yüksek Talep Gören Diller',
          content: 'Çince (Mandarin), Arapça, Japonca, Korece, Almanca, Fransızca, İspanyolca en çok aranan dillerdir.'
        },
        {
          title: 'Dil Primi',
          content: 'Birçok havayolu nadir dil bilenlere ek maaş öder. Bu aylık yüzlerce dolar olabilir.'
        },
        {
          title: 'Rota Önceliği',
          content: 'Belirli dilleri bilenler, o dili konuşulan ülkelere giden uçuşlarda öncelikli olarak görevlendirilir.'
        }
      ],
      tips: ['En az bir dil daha öğrenin', 'Dil sertifikalarınızı güncel tutun', 'CV\'nizde dil seviyelerinizi net belirtin']
    }
  },
  'CM-M2-U4-L3': {
    title: 'Etkili İletişim Teknikleri',
    type: 'lesson',
    content: {
      introduction: 'Kabin ortamında başarılı iletişim için gerekli teknikler.',
      sections: [
        {
          title: 'Aktif Dinleme',
          content: 'Yolcunun söylediklerine tam dikkat verme, göz teması kurma, onaylayıcı ifadeler kullanma.'
        },
        {
          title: 'Açık ve Net Konuşma',
          content: 'Uçak gürültüsünde bile anlaşılır konuşma, jargondan kaçınma, kısa ve öz ifadeler.'
        },
        {
          title: 'Sözsüz İletişim',
          content: 'Beden dili, yüz ifadesi, duruş. Söyledikleriniz kadar nasıl söylediğiniz de önemli.'
        }
      ],
      tips: ['Gülümseyin - sesle bile duyulur', 'Sabırlı olun', 'Onaylama ile sonlandırın']
    }
  },
  'CM-M2-U4-L4': {
    title: '⚡ Dil Bilgisi Yarışı',
    type: 'timerace',
    game: {
      instruction: '45 saniyede dil ve iletişim sorularını cevaplayın!',
      questions: [
        { question: 'Kabin memurluğunda minimum İngilizce seviyesi?', answer: 'B2', options: ['A1', 'A2', 'B2', 'C2'] },
        { question: 'En çok talep gören Asya dili?', answer: 'Çince', options: ['Çince', 'Hintçe', 'Tayca', 'Vietnamca'] },
        { question: 'Aktif dinlemenin bir unsuru?', answer: 'Göz teması', options: ['Göz teması', 'Telefona bakma', 'Sözünü kesme', 'Acele etme'] },
        { question: 'Dil primi ne sağlar?', answer: 'Ek maaş', options: ['Ek izin', 'Ek maaş', 'Terfi', 'Eğitim'] },
        { question: 'TOEIC ne ölçer?', answer: 'İngilizce yetkinliği', options: ['Boy', 'Kilo', 'İngilizce yetkinliği', 'Matematik'] }
      ],
      timeLimit: 45
    }
  },

  // Ünite 5 - Görünüm ve Grooming
  'CM-M2-U5-L1': {
    title: 'Grooming Standartları',
    type: 'lesson',
    content: {
      introduction: 'Havayollarının kabin ekibi için belirlediği görünüm standartları.',
      sections: [
        {
          title: 'Saç ve Makyaj (Kadın)',
          content: 'Düzgün topuz veya belirlenen saç modeli, doğal tonlarda makyaj, belirli renk rujlar. Tırnaklar bakımlı ve kabul edilen renklerde.'
        },
        {
          title: 'Saç ve Bakım (Erkek)',
          content: 'Kısa ve düzenli saç kesimi, temiz traşlı veya bakımlı sakal (izin veriliyorsa), bakımlı tırnaklar.'
        },
        {
          title: 'Üniforma ve Aksesuarlar',
          content: 'Temiz ve ütülü üniforma, cilalı ayakkabılar, belirlenmiş aksesuarlar. Aşırı takı yasaktır.'
        },
        {
          title: 'Vücut Bakımı',
          content: 'Kişisel hijyen, hoş koku (aşırı parfüm değil), görünür dövme ve piercing kuralları.'
        }
      ],
      tips: ['Her havayolunun kendi kuralları var', 'Mülakatta da bu standartlara uyun', 'Detaylar önemlidir']
    }
  },
  'CM-M2-U5-L2': {
    title: 'Mülakat Görünümü',
    type: 'lesson',
    content: {
      introduction: 'İş görüşmesine nasıl bir görünümle gitmelisiniz?',
      sections: [
        {
          title: 'Kadın Adaylar',
          content: 'Diz altı etek veya pantolon takım, doğal makyaj, düzgün saç (tercihen topuz), kapalı topuklu ayakkabı (5-7 cm), minimal takı.'
        },
        {
          title: 'Erkek Adaylar',
          content: 'Takım elbise (koyu renk tercih), temiz traş, düzgün saç, cilalı ayakkabı, kravat.'
        },
        {
          title: 'Genel Kurallar',
          content: 'Temiz ve ütülü kıyafetler, bakımlı tırnaklar, doğal görünüm, profesyonel duruş.'
        }
      ],
      tips: ['Havayolunun renklerini araştırın', 'Aşırıya kaçmayın', 'Rahatsız hissetmeyeceğiniz kıyafetler seçin']
    }
  },
  'CM-M2-U5-L3': {
    title: '🎮 Grooming Doğru/Yanlış',
    type: 'truefalse',
    game: {
      instruction: 'Grooming kuralları hakkındaki ifadeleri değerlendirin.',
      statements: [
        { statement: 'Parlak kırmızı oje mülakatta uygunudur', isTrue: false, explanation: 'Doğal tonlar tercih edilir, parlak renkler genellikle uygun değildir' },
        { statement: 'Görünür dövmeler genellikle kapatılmalıdır', isTrue: true, explanation: 'Çoğu havayolu görünür dövmeyi kabul etmez veya kapatılmasını ister' },
        { statement: 'Erkek adaylar sakal bırakabilir', isTrue: false, explanation: 'Çoğu havayolu temiz traş ister, bazıları bakımlı sakala izin verir' },
        { statement: 'Mülakatta topuklu ayakkabı zorunludur', isTrue: false, explanation: 'Zorunlu değil ama profesyonel görünüm için önerilir (kadınlar için)' },
        { statement: 'Parfüm kullanımı tavsiye edilir', isTrue: false, explanation: 'Hafif koku kabul edilir ama yoğun parfüm önerilmez' }
      ]
    }
  },

  // Ünite 6 - Final Quiz
  'CM-M2-U6-L1': {
    title: '🎓 Modül 2 Final Sınavı',
    type: 'exam',
    exam: {
      title: 'Havayolları Adaydan Ne Bekler? - Final Sınavı',
      passingScore: 70,
      questions: [
        {
          question: 'Kabin memurluğu için aranan en önemli kişilik özelliği hangisidir?',
          options: ['Liderlik', 'Empati ve duygusal zeka', 'Hırs', 'Rekabetçilik'],
          correct: 1
        },
        {
          question: 'Minimum İngilizce seviyesi genellikle ne olmalıdır?',
          options: ['A1', 'A2', 'B2', 'Native'],
          correct: 2
        },
        {
          question: 'Dil primi nedir?',
          options: ['Yabancı dil kursu ücreti', 'Nadir dil bilenlere verilen ek maaş', 'Çeviri ücreti', 'Sınav ücreti'],
          correct: 1
        },
        {
          question: 'Mülakatta kadın adaylar için önerilen topuk yüksekliği?',
          options: ['0-3 cm', '5-7 cm', '10+ cm', 'Topuk gerekmez'],
          correct: 1
        },
        {
          question: 'Grooming kuralları neden önemlidir?',
          options: ['Moda için', 'Profesyonel imaj ve marka temsili için', 'Kişisel zevk için', 'Zorunlu değildir'],
          correct: 1
        },
        {
          question: 'Kültürel farkındalık ne anlama gelir?',
          options: ['Sadece kendi kültürünü bilmek', 'Farklı kültürlere saygı ve anlayış', 'Yabancı dil bilmek', 'Seyahat etmek'],
          correct: 1
        },
        {
          question: 'Aktif dinlemenin bir parçası olan davranış hangisidir?',
          options: ['Sözünü kesmek', 'Telefona bakmak', 'Göz teması kurmak', 'Acele etmek'],
          correct: 2
        },
        {
          question: 'En çok talep gören ikinci dil kategorisi?',
          options: ['Ölü diller', 'Asya dilleri', 'Latin dilleri', 'İşaret dili'],
          correct: 1
        }
      ]
    }
  }
};

export default cabinCrewContentsM2Extra;
